export function registerServiceWorker() {
  if (import.meta.env.MODE === "development") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => console.log("Service worker registered"))
      .catch((error) => console.error("Service worker registration failed", error));
  });
}

